import { render, staticRenderFns } from "./IcoLearningProgramContent.vue?vue&type=template&id=462ccfb4"
import script from "./IcoLearningProgramContent.vue?vue&type=script&lang=js"
export * from "./IcoLearningProgramContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports